// extracted by mini-css-extract-plugin
export default {"body":"PageBody_body__lBwQC"};